module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.478/img/screenshot-twitter.png"